import { IBorderRadiusData, ICommonStyles, IFavoriteData, IMeshSectionBaseData, IMeshedSectionContentData, IScreenData, ISectionStyle, IVisibility, MeshedSectionContentData } from "./index";

export interface IPopUpPageData {
    type: "PopUpPage";
    lang: string;
    commonStyles: ICommonStyles;
    popUp: IPopUpData;
}

export interface IPopUpData {
    readonly type: "PopUp";
    readonly id: "pop-up";
    popupInfo?: IPopUpInfo;
    popupSection?: IPopUpSectionData; // filled only for cascade rendering, otherwise is undefined
}

export interface IPopUpInfo {
    siteHash: string;
    popupHash: string;
}

export interface IPopUpSectionData extends IMeshSectionBaseData<IPopUpStyle>, IScreenData, IFavoriteData {
    readonly type: "PopUpSection";
    readonly sectionName: string;
    id?: string;
    layout: PopupLayoutType;
    popupSettings?: IPopupSettings | null;
}

export interface IPopUpStyle extends ISectionStyle {
    widthInPc : number;
    closeColor: string;
    borderRadius?: IBorderRadiusData | null;
}

export interface IPopupSettings {
    popupTrigger: IPopupTriggerModel;
    frequency: string;
}

export interface IPopupTriggerModel {
    triggerType: string;
    triggerTimer: string | null;
    triggerScroll: string | null;
}

export type PopupLayoutType = "Center" | "BottomLeft" | "BottomRight" | "TopLeft" | "TopRight" | "FullScreen" | "RightSidebar" | "LeftSidebar" | "BottomSidebar" | "TopSidebar";

export abstract class PopUpSectionData {

    public static get defaultData(): IPopUpSectionData {
        return {
            type: "PopUpSection",
            sectionName: "popUp",
            layout: "Center",
            style: this.defaultStyle,
            background: {
                style: {
                    color: `rgba(255, 255, 255, 1)`
                }
            },
            content: this.defaultContent,
            popupSettings: this.defaultSettings,
            sectionVisibility: this.defaultSectionVisibility
        };
    }

    public static get defaultStyle(): IPopUpStyle {
        return {
            closeColor: "#7B828E",
            widthInPc: 50,
            borderRadius: {
                topLeftPx: 10,
                topRightPx: 10,
                bottomLeftPx: 10,
                bottomRightPx: 10
            },
            minHeightInPc: 50
        };
    }

    public static get defaultSettings(): IPopupSettings {
        return {
            popupTrigger: {
                triggerType: PopupTriggerType.ShowOnTimer,
                triggerTimer: PopupTriggerTimer.After5Sec,
                triggerScroll: null
            },
            frequency: PopupFrequency.NextDay
        };
    }

    public static get defaultContent(): IMeshedSectionContentData {
        return MeshedSectionContentData.defaultData;
    }

    public static get defaultSectionVisibility(): IVisibility {
        return {
            desktop: true,
            tablet: true,
            mobile: true
        };
    }

}

export enum PopupTriggerType {
    ShowOnTimer = "ShowOnTimer",
    ShowOnScroll = "ShowOnScroll",
    ShowOnTimerAndScroll = "ShowOnTimerAndScroll",
    ShowOnExitPage = "ShowOnExitPage"
}

export enum PopupFrequency {
    Never = "Never",
    NextDay = "NextDay",
    InOneWeek = "InOneWeek",
    InTwoWeek = "InTwoWeek",
    In30Days = "In30Days",
    Always = "Always"
}

export enum PopupTriggerTimer {
    Immediately = "Immediately",
    After5Sec = "After5Sec",
    After10Sec = "After10Sec",
    After30Sec = "After30Sec",
}

export enum PopupTriggerScroll {
    Down25Percent = "Down25Percent",
    Down50Percent = "Down50Percent",
    Down75Percent = "Down75Percent",
}
